"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getA18n = void 0;
var translator_1 = require("./translator");
var DEFAULT_NAMESPACE = '__default_namespace__';
// @ts-ignore
var langs = typeof navigator !== 'undefined' ? navigator.languages || [] : [];
var DEFAULT_LOCALE = langs[0] || 'en-US';
var ROOT = '__$a18n-instances';
/** globalThis */
var _global = typeof globalThis !== 'undefined'
    ? globalThis
    : typeof window !== 'undefined'
        ? window
        : typeof global !== 'undefined'
            ? global
            : (function () {
                console.warn('[a18n] cannot resolve globalThis, sharing by namespace is disabled');
                return {};
            })();
var globalInstances = _global[ROOT] || (_global[ROOT] = {});
var localInstances = {};
var getA18n = function (namespace) {
    return globalInstances[namespace] || (globalInstances[namespace] = create());
};
exports.getA18n = getA18n;
var create = function () {
    var _a;
    var currentLocale = DEFAULT_LOCALE;
    var resources = (_a = {},
        _a[currentLocale] = {},
        _a);
    /** must always be a reference to resources, `addLocaleResource` depend on this  */
    var resource = resources[currentLocale];
    var addLocaleResource = function (locale, res) {
        if (!resources[locale]) {
            resources[locale] = {};
        }
        Object.assign(resources[locale], res);
        translator_1.clearCompileCache();
    };
    var setLocale = function (locale) {
        if (typeof locale !== 'string') {
            throw new TypeError("'locale' is expect to be a string");
        }
        currentLocale = locale;
        if (!resources[currentLocale]) {
            resources[currentLocale] = {};
        }
        resource = resources[currentLocale];
        translator_1.clearCompileCache();
    };
    function a18n(text) {
        if (typeof text === 'string') {
            var translated = resource[text];
            if (typeof translated === 'string') {
                return translated;
            }
            return text;
        }
        if (text && typeof text.length === 'number') {
            var template = translator_1.compile(text, resource);
            var args = arguments;
            var result = '';
            for (var index = 0; index < template.length; index++) {
                var item = template[index];
                result += typeof item === 'number' ? String(args[item]) : item;
            }
            return result;
        }
        console.warn('[a18n] invalid input:', arguments);
        return String(text);
    }
    //-------------- instance methods --------------
    a18n.x = function (text) {
        if (typeof text.length === 'number') {
            var template = translator_1.compile(text, resource);
            var args = arguments;
            var result = [];
            for (var index = 0; index < template.length; index++) {
                var item = template[index];
                result.push(typeof item === 'number' ? args[item] : item);
            }
            return result;
        }
        console.warn('[a18n] invalid input:', arguments);
        return [text];
    };
    a18n.addLocaleResource = addLocaleResource;
    a18n.setLocale = setLocale;
    a18n.getLocale = function () { return currentLocale; };
    //-------------- static methods --------------
    a18n.getA18n = getA18n;
    a18n.DEBUG_reset = function (resetSelfOnly) {
        if (resetSelfOnly === void 0) { resetSelfOnly = false; }
        resources = {};
        resource = {};
        currentLocale = DEFAULT_LOCALE;
        translator_1.clearCompileCache();
        if (!resetSelfOnly) {
            var instances = []
                .concat(Object.values(globalInstances))
                .concat(Object.values(localInstances));
            instances.forEach(function (instance) {
                if (instance !== a18n) {
                    instance.DEBUG_reset(true);
                }
            });
        }
    };
    a18n.DEBUG_print = function () {
        var compileCache = translator_1.DEBUG_getCompileCache();
        console.log(JSON.stringify({ currentLocale: currentLocale, resources: resources, resource: resource, compileCache: compileCache }, null, 2));
        return { currentLocale: currentLocale, resources: resources, resource: resource, compileCache: compileCache };
    };
    return a18n;
};
var a18n = (localInstances[DEFAULT_NAMESPACE] = create());
module.exports = a18n;
exports.default = a18n;
